import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reviews",
  "use": "icon-reviews-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-reviews\">\n  <path d=\"M15.3335 13.3333H11.2763L9.00016 15.6095L6.72402 13.3333H2.66683L2.66683 3.33333L15.3335 3.33333V13.3333ZM12.6668 2.33333H1.66683L1.66683 10.3333H0.333496L0.333497 1L12.6668 1V2.33333Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol